import { PostTypeShort } from '~publish/legacy/post/constants'

import type { ServiceMediaRestrictions } from './types'
import { CommonRatios } from '../aspect-ratio/CommonRatios'
import { aspectRatioRange } from '../validation/rules/aspectRatioRange'

export const YoutubeMediaRestrictions: ServiceMediaRestrictions = {
  [PostTypeShort]: {
    videos: [
      aspectRatioRange.define(
        {
          min: CommonRatios['9:16'],
          max: CommonRatios['1:1'],
        },
        {
          messages: {
            generic:
              'Video dimensions are invalid. Aspect ratio must be between 9:16 (vertical) and 1:1 (square)',
          },
        },
      ),
    ],
  },
}
